import { types } from "../../types/types";

const initialState = {
    receiversData: []
}

export const ReceiverBillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.receiverData:
      return{
        ...state,
        receiversData: [ ...action.payload]
      }
      
    default:
      return state;
  }
}
